import * as R from "ramda";
import React from "react";
import Tooltip from "ui-kit/Tooltip";
import { connect } from "react-redux";
import { getValue, getSettings, getAllValues } from "../../utils";

import { eventDetails } from "redux/modules/event/selectors";

const decorate = connect(state => ({
  eventDetails: eventDetails(state)
}));

const SpeakersDropdown = props => {
  const records = getValue(props, "records", []);
  const options = getSettings(props, "options", []);
  const eventId = R.propOr("", "id", props.eventDetails);
  const url = `/event-light/${eventId}/sessions`;
  return (
    <div
      style={{
        userSelect: "none",
        overflow: "hidden",
        display: "flex",
        alignItems: "left",
        justifyContent: "flex-start"
      }}
    >
      <Tooltip
        tooltip={getAllValues(records)}
        style={{
          left: 0,
          padding: "0 .75rem",
          display: "flex",
          flex: "1 0 auto",
          textAlign: "left"
        }}
      >
        {R.map(record => {
          if (record && record.value && typeof record.value !== "object") {
            const selectedOption = R.find(R.propEq("id", record.id), options);
            return (
              <div
                key={record.id}
                style={{
                  marginRight: 4,
                  borderRadius: 4,
                  fontSize: 12,
                  padding: "4px 8px",
                  lineHeight: "normal",
                  whiteSpace: "nowrap",
                  flexBasis: "auto",
                  flexShrink: 0,
                  backgroundColor:
                    R.prop("backgroundColor", selectedOption) || "#EBEBEB",
                  color: R.prop("textColor", selectedOption) || "#494949"
                }}
              >
                <a href={`${url}/${record.id}`} target="_blank">
                  {record.value}
                </a>
              </div>
            );
          }
          return "";
        }, records)}
      </Tooltip>
    </div>
  );
};

export default decorate(SpeakersDropdown);
